
import { Modal, Box, Typography, Button, Stack, Divider } from "@mui/material";

type DeleteConfirmHQLocationDashBoardModalProps = {
  open: boolean;
  location: {
    formatted_address: string;
    place_id: string;
    lat: number;
    lng: number;
  } | null;
  handleDeleteConfirm: () => void;
  handleDeleteClose: () => void;
};

const DeleteConfirmHQLocationDashBoardModal = ({
  open,
  handleDeleteClose,
  handleDeleteConfirm,
  location,
}: DeleteConfirmHQLocationDashBoardModalProps) => {
  return (
    <Modal open={open} onClose={() => {}} sx={{ backdropFilter: "blur(0.1px)" }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 10,
          p: 4,
          width: { xs: "90%", sm: "50%", md: "35%" },
          maxWidth: 480,
          textAlign: "center",
        }}
      >
    
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Confirm Delete HQ Location?
        </Typography>

      
        <Divider sx={{ mb: 2 }} />

        <Typography variant="body1" color="text.secondary" mb={3}>
          {location?.formatted_address || "No location selected"}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDeleteClose}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteConfirm}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
              boxShadow: 2,
              "&:hover": { boxShadow: 4 },
            }}
          >
            DELETE
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmHQLocationDashBoardModal;

